import { render, staticRenderFns } from "./ScoreBar.vue?vue&type=template&id=70a58d53&scoped=true&"
import script from "./ScoreBar.vue?vue&type=script&lang=js&"
export * from "./ScoreBar.vue?vue&type=script&lang=js&"
import style0 from "./ScoreBar.vue?vue&type=style&index=0&id=70a58d53&prod&scoped=true&lang=css&"
import style1 from "./ScoreBar.vue?vue&type=style&index=1&id=70a58d53&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a58d53",
  null
  
)

export default component.exports